module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/banner/th-b107587506f48e3d5c03aae9678bfe9b.jpg";